import { ModulesEnum } from '../enums/modules.enum';

export const LIST_SORT_SETTINGS_KEY = 'listSort';

export type ListSortPreferences = Partial<Record<ModulesEnum, string>>;

const MODULE_IDS = new Set<string>(Object.values(ModulesEnum));

export function parseListSortPreferences(raw: unknown): ListSortPreferences {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) {
    return {};
  }

  const preferences: ListSortPreferences = {};
  for (const [key, value] of Object.entries(raw)) {
    if (!MODULE_IDS.has(key) || typeof value !== 'string' || value.length === 0) {
      continue;
    }
    preferences[key as ModulesEnum] = value;
  }
  return preferences;
}

export function listSortPreferencesToBagValue(
  prefs: ListSortPreferences,
): Record<string, unknown> {
  return { ...prefs };
}
